import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { getImagePath } from '../../utils/imagePath';

const OurStory = () => {
  const [videoModalOpen, setVideoModalOpen] = useState(false);

  // Past Presidents data with actual image paths
const pastPresidents = [
  { name: 'Wilmer Bleik', tenure: 'Pioneer Club President', image: getImagePath('images/team/Img11.jpg') },
  { name: 'Isa Mohammed', tenure: 'Second Pioneer Club President', image: getImagePath('images/team/img13.jpg') },
  { name: 'Wilmer Bleik', tenure: '2nd Tenure', image: getImagePath('images/team/Img11.jpg') },
  { name: 'Henry Agbodjan', tenure: '2008 - 2011', image: getImagePath('images/team/Img4.jpg') },
  { name: 'Chidi Ikocha', tenure: '2011 - 2013', image: getImagePath('images/team/Img1.jpg') },
  { name: 'Tula Olawe', tenure: '2013 - 2015', image: getImagePath('images/team/Img6.jpg') },
  { name: 'Ozaveshe Omoluabi', tenure: '2015 - 2017', image: getImagePath('images/team/Img8.jpg') },
  { name: 'Emmanuel Archibong', tenure: '2017 - 2020', image: getImagePath('images/team/Img5.jpg') },
  { name: 'Excel Ukpohor', tenure: '2020 - 2022', image: getImagePath('images/team/Img2.jpg') },
  { name: 'Temitope Ogedengbe', tenure: '2022 - 2024', image: getImagePath('images/team/Img3.jpg') },
];
  // Milestones data for the "Milestones of Excellence" section
  const milestonesData = [
    {
      title: 'Infrastructure Development',
      description:
        'Continuous investment in world-class facilities, including a state-of-the-art clubhouse, sports courts, swimming pools, and children\'s play areas.',
      icon: 'fa-building',
    },
    {
      title: 'Signature Events',
      description:
        'Annual festivals, sports tournaments, cultural nights, and charity drives that bring together diverse cultures and talents within the community.',
      icon: 'fa-calendar-alt',
    },
    {
      title: 'Capacity Building',
      description:
        'Leadership workshops, educational seminars, and skill-building programs to empower members and foster intellectual growth.',
      icon: 'fa-chalkboard-user',
    },
  ];

  return (
    <div className="our-story-page">
      {/* Hero Section - Apple Style */}
      <section className="story-hero-section">
        <div className="story-hero-background">
          <img
            src="https://images.unsplash.com/photo-1540497077202-7c8a3999166f?q=80&w=1920&auto=format&fit=crop"
            alt="Club Heritage"
          />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <motion.div
            className="story-hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="hero-mini-title">THE CLUB</span>
            <h1 className="hero-main-title">
              Our <span className="text-green">Story</span>
            </h1>
            <p className="hero-description">
              Discover the rich heritage and journey of NLNG RA Club since 1995
            </p>
          </motion.div>
        </div>
      </section>

      {/* Stats Bar - Apple Style */}
      <section className="story-stats-bar">
        <div className="container">
          <div className="stats-bar-grid">
            <div className="stat-bar-item">
              <span className="stat-bar-number">31+</span>
              <span className="stat-bar-label">Years of Excellence</span>
            </div>
            <div className="stat-bar-divider"></div>
            <div className="stat-bar-item">
              <span className="stat-bar-number">2,500+</span>
              <span className="stat-bar-label">Elite Members</span>
            </div>
            <div className="stat-bar-divider"></div>
            <div className="stat-bar-item">
              <span className="stat-bar-number">15+</span>
              <span className="stat-bar-label">World-Class Facilities</span>
            </div>
          </div>
        </div>
      </section>

      {/* The Beginning Section */}
      <section className="story-beginning-section">
        <div className="container">
          <div className="section-header-center">
            <span className="section-tag">OUR ORIGIN</span>
            <h2 className="section-heading">
              The <span className="text-green">Beginning</span>
            </h2>
          </div>
          <div className="beginning-content">
            <p className="beginning-text">
              The NLNG Residential Area (RA) Club was established as a vibrant hub for community
              interaction, recreation, and personal development within the Nigeria LNG Limited
              Residential Area. Founded with the vision of fostering unity, well-being, and a sense
              of belonging, the RA Club has evolved into a cornerstone of community life,
              reflecting the values and aspirations of its members.
            </p>
          </div>
        </div>
      </section>

      {/* Milestones of Excellence Section - 3 Cards */}
      <section className="story-milestones-section">
        <div className="container">
          <div className="section-header-center">
            <span className="section-tag">MILESTONES OF EXCELLENCE</span>
            <h2 className="section-heading">
              Our Journey of <span className="text-green">Growth</span>
            </h2>
            <p className="section-description">
              Key initiatives that have set us apart as a model residential community club
            </p>
          </div>
          <div className="milestones-grid">
            {milestonesData.map((item, index) => (
              <motion.div
                key={index}
                className="milestone-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -5 }}
              >
                <div className="milestone-icon">
                  <i className={`fas ${item.icon}`}></i>
                </div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Community Impact Section */}
      <section className="story-impact-section">
        <div className="container">
          <div className="impact-grid">
            <div className="impact-text">
              <span className="section-tag">BEYOND RECREATION</span>
              <h2 className="section-heading">
                Community <span className="text-green">Impact</span>
              </h2>
              <p className="impact-description">
                The RA Club is more than a recreational hub—it is a catalyst for positive social
                change. Through its outreach programs, the club has supported charitable causes,
                promoted environmental sustainability, and encouraged youth engagement in meaningful
                activities. Its efforts continue to resonate beyond the Residential Area, earning
                admiration within the larger Bonny Island community.
              </p>
              <div className="impact-stats">
                <div className="impact-stat">
                  <span className="stat-number">50+</span>
                  <span className="stat-label">Charity Events</span>
                </div>
                <div className="impact-stat">
                  <span className="stat-number">20+</span>
                  <span className="stat-label">Sustainability Projects</span>
                </div>
                <div className="impact-stat">
                  <span className="stat-number">1000+</span>
                  <span className="stat-label">Youth Engaged</span>
                </div>
              </div>
            </div>
            <div className="impact-image">
              <img
                src="https://images.unsplash.com/photo-1532629345422-7515f3d16bb6?q=80&w=800&auto=format&fit=crop"
                alt="Community Impact"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Past Club Presidents Section */}
      <section className="story-presidents-section">
        <div className="container">
          <div className="section-header-center">
            <span className="section-tag">LEADERSHIP LEGACY</span>
            <h2 className="section-heading">
              Past Club <span className="text-green">Presidents</span>
            </h2>
            <p className="section-description">
              The heroes who laid the foundation, and on whose shoulders we stand
            </p>
          </div>
          <div className="presidents-grid">
            {pastPresidents.map((president, index) => (
              <motion.div
                key={index}
                className="president-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: (index % 10) * 0.05 }}
                viewport={{ once: true }}
                whileHover={{ y: -5 }}
              >
                <div className="president-image">
                  <img 
                    src={president.image} 
                    alt={president.name}
                    onError={(e) => {
                      e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                        president.name
                      )}&background=28a745&color=fff&size=200`;
                    }}
                  />
                </div>
                <div className="president-info">
                  <h3>{president.name}</h3>
                  <p className="president-tenure">{president.tenure}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Video Story Section - Apple Style */}
      <section className="story-video-section">
        <div className="container">
          <div className="video-story-grid">
            <div className="video-story-text">
              <span className="section-tag">WATCH OUR STORY</span>
              <h2 className="section-heading">
                Experience the <span className="text-green">Journey</span>
              </h2>
              <p className="video-story-description">
                Take a visual journey through the history of NLNG RA Club. From our founding days
                to the present, witness how we've grown and evolved while maintaining our commitment
                to excellence and community.
              </p>
              <div className="video-story-features">
                <div className="feature-item">
                  <i className="fas fa-check-circle"></i>
                  <span>30+ Years of Heritage</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-check-circle"></i>
                  <span>2,500+ Happy Members</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-check-circle"></i>
                  <span>15+ Premium Facilities</span>
                </div>
              </div>
            </div>
            <div className="video-story-player">
              <div className="video-thumbnail">
                <img
                  src="https://images.unsplash.com/photo-1540497077202-7c8a3999166f?q=80&w=800&auto=format&fit=crop"
                  alt="Play Video"
                />
                <button className="video-play-btn" onClick={() => setVideoModalOpen(true)}>
                  <div className="play-icon">
                    <i className="fas fa-play"></i>
                  </div>
                  <span>Watch Film</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Video Modal */}
      <AnimatePresence>
        {videoModalOpen && (
          <motion.div
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setVideoModalOpen(false)}
          >
            <motion.div
              className="modal-content video-modal"
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.9 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button className="modal-close-btn" onClick={() => setVideoModalOpen(false)}>
                <i className="fas fa-times"></i>
              </button>
              <div className="video-player-container">
                <video controls autoPlay>
                  <source src="https://nlngraclub.com/Boulevard.mp4" type="video/mp4" />
                </video>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default OurStory;